import request from './request'
const customer = 'CUSTOMER-SERVE'

export function findList(data) {
  return request({
    url: customer + '/process/findActiveEvent',
    method: 'post',
    data
  })
}

export function findActiveEventList(data) {
  return request({
    url: customer + '/materialApplyProcess/findActiveEvent',
    method: 'post',
    data
  })
}

export function findActiveDeliveryList(data) {
  return request({
    url: customer + '/materialDelivery/findActiveEvent',
    method: 'post',
    data
  })
}





export function findDelayApproves(data) {
  return request({
    url: customer + '/process/findDelayApproves',
    method: 'post',
    data
  })
}

export function exportDelayApproves(data) {
  return request({
    url: customer + '/process/export',
    method: 'post',
    responseType: 'blob',
    data
  })
}

export function findHistTask(data) {
  return request({
    url: customer + '/process/findHistTask',
    method: 'post',
    data
  })
}

export function findHistTaskList(data) {
  return request({
    url: customer + '/materialApplyProcess/findHistTask',
    method: 'post',
    data
  })
}


export function findHistDeliveryList(data) {
  return request({
    url: customer + '/materialDelivery/findHistTask',
    method: 'post',
    data
  })
}



export function findTaskInfos(data) {
  return request({
    url: customer + '/dmsApprove/getTaskInfos',
    method: 'post',
    data
  })
}

export function findDisTaskInfos(data) {
  return request({
    url: customer + '/dmsApprove/getDisTaskInfos',
    method: 'post',
    data
  })
}

export function findProcessInfos(data) {
  return request({
    url: customer + '/dmsApprove/getProcessNodes',
    method: 'post',
    data
  })
}

export function approveStart(data) {
  return request({
    url: customer + '/dmsApprove/approveStart',
    method: 'post',
    data
  })
}

export function approveExecute(data) {
  return request({
    url: customer + '/dmsApprove/approveExecute',
    method: 'post',
    data
  })
}

export function approveRestart(data) {
  return request({
    url: customer + '/dmsApprove/approveRestart',
    method: 'post',
    data
  })
}

export function executeLastNode(data) {
  return request({
    url: customer + '/dmsApprove/executeLastNode',
    method: 'post',
    data
  })
}

export function executeAndJumpFirst(data) {
  return request({
    url: customer + '/dmsApprove/executeAndJumpFirst',
    method: 'post',
    data
  })
}

export function transfer(data) {
  return request({
    url: customer + '/dmsApprove/transfer',
    method: 'post',
    data
  })
}


// 获取该经销商15天内能提报的所有活动
export function download(code) {
  return request({
    url: customer + '/image/download?code=' + code,
    responseType: 'blob', // 重要！设置响应类型为blob
    method: 'get'
  })
}


